import { defineMessages } from "react-intl";

const messages = defineMessages({
  changeStepConfirmation: {
    id: "settings.newImports.changeStepConfirmation",
    defaultMessage: "Are you sure you want to continue without saving your field matching?",
    description: "Text of import step changing confirmation",
  },
  collapsePanelTitle: {
    id: "settings.newImports.collapsePanel.title",
    defaultMessage:
      "Follow the step-by-step instructions to bring your spreadsheet data into Map My Customers",
    description: "Text of collapse panel",
  },
  continueWithoutSaving: {
    id: "settings.newImports.continueWithoutSaving",
    defaultMessage: "Continue without saving",
    description: "Continue without saving button on import matching page",
  },
  createConfigModalOkText: {
    id: "settings.newImports.createConfigModalOkText",
    defaultMessage: "Save and continue",
    description: "Save and continue text on import matching page",
  },
  matchRequired: {
    id: "settings.newImports.error.matchRequired",
    defaultMessage:
      "You must match every required field marked with (*) to a column in order to import",
    description: "Import step 2 error message",
  },
  saveMatching: {
    id: "settings.newImports.saveMatching",
    defaultMessage: "Save matching",
    description: "Save matching button on import matching page",
  },
  saveNewMatchingDescription: {
    id: "settings.newImports.saveNewMatchingDescription",
    defaultMessage:
      "We recommend that you save your matching in case you’d like to edit or reference them in the future.",
    description: "Save new matching description on import matching page",
  },
  saveNewMatchingTitle: {
    id: "settings.newImports.saveNewMatchingTitle",
    defaultMessage: "Save new matching for future use?",
    description: "Save new matching title on import matching page",
  },
});

export default messages;
